import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import OtpInput from "react-otp-input";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	// width: 400,
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	p: 3,
};

const inputStyle = {
	width: "2.5rem",
	height: "2.5rem",
	margin: "0 1rem",
	fontSize: "2rem",
	borderRadius: 4,
	border: "1px solid rgba(0,0,0,0.3)",
};

const errorStyle = {
	color: "red",
	border: "1px solid red !important",
};

export default function BasicModal({
	open,
	handleClose,
	otp,
	handleChange,
	handleOtpRequest,
	handleVerifyOtp,
}) {
	return (
		<div>
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				// onBackdropClick={handleClose}
			>
				<Box sx={style}>
					<Typography
						id="modal-modal-description"
						sx={{ mb: "2rem", textAlign: "center" }}
						variant="body1"
					>
						Please enter the OTP sent to your email
					</Typography>

					<Box sx={{ mb: "2rem" }}>
						<OtpInput
							inputStyle={inputStyle}
							value={otp}
							isInputNum
							onChange={handleChange}
							numInputs={6}
							shouldAutoFocus
							errorStyle={errorStyle}
							separator={<span>-</span>}
						/>
					</Box>

					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
						}}
					>
						<Button
							variant="contained"
							color="primary"
							onClick={() => handleVerifyOtp()}
							sx={{ mb: "1rem" }}
						>
							verify
						</Button>
					</Box>
					<Typography sx={{ textAlign: "center" }} variant="body2">
						Didn't receive the verification OTP?{" "}
						<Button
							variant="text"
							color="primary"
							sx={{ textTransform: "none" }}
							onClick={() => handleOtpRequest()}
						>
							Resend again
						</Button>
					</Typography>
				</Box>
			</Modal>
		</div>
	);
}
